// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchItemDetailsByIdsParams = {
    authToken?: string,
    deployment: string,
    itemIds: number[],
};

export default {
    fetchItemDetailsByIds: ({ authToken, deployment, itemIds }: FetchItemDetailsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/item-detail' });
            request.send({ itemIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
